// extracted by mini-css-extract-plugin
export var text = "_bm-0";